import { useAtom } from "jotai";
import { venueSearchParamsAtom } from "./atoms";

export function useSearchPageParams() {
  const [searchPageParams, setSearchPageParams] = useAtom(
    venueSearchParamsAtom
  );
  return { searchPageParams, setSearchPageParams };
}
